import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { InputLabelEl } from './label';
export function template() {
  const {
    value
  } = this.state;
  return jsx("div", {
    sel: '.mp-input-container'
  }, this.attr("label") ? jsx(InputLabelEl, {
    attrs: {
      label: this.attr("label"),
      'field-id': this.attr("field-id"),
      necessary: this.attr("necessary"),
      'help-text': this.attr("help-text"),
      'extra-info': this.attr("extra-info")
    }
  }) : null, jsx("div", {
    sel: '.mp-input-field-container'
  }, (() => {
    const TagName = this.attr("type") === "textarea" ? "textarea" : "input";
    return jsx(null, null, this.attr("icon") ? jsx("div", {
      sel: '.mp-input-left-icon'
    }, jsx(SvgIconEl, {
      attrs: {
        icon: this.attr("icon")
      }
    })) : null, jsx(TagName, {
      sel: '.mp-input',
      class: {
        ["is-".concat(this.attr("validation-status"))]: Boolean(this.attr("validation-status")),
        'left-icon': Boolean(this.attr("icon"))
      },
      style: {
        'text-align': this.attr("text-align")
      },
      attrs: {
        elref: "inputTag",
        id: this.attr("field-id"),
        name: this.attr("field-name"),
        placeholder: this.attr("placeholder"),
        disabled: this.attr("disabled"),
        readonly: this.attr("readonly"),
        type: TagName === "input" ? this.attr("type") : null,
        maxlength: this.attr("maxlength"),
        min: TagName === "input" ? this.attr("min") : null
      },
      props: {
        value
      },
      on: {
        input: this.helpers.handleInput,
        blur: this.helpers.handleBlur,
        focus: this.helpers.handleFocus,
        change: this.helpers.handleChange
      },
      hook: {
        insert: (_ref) => {
          let {
            elm
          } = _ref;
          return this.setElmRef(elm);
        }
      }
    }), this.attr("validation-status") ? jsx("div", {
      sel: '.mp-input-right-icon'
    }, jsx(SvgIconEl, {
      attrs: {
        icon: {
          valid: "circle-checkmark",
          invalid: "warning"
        }[this.attr("validation-status")]
      }
    })) : value && this.attr("show-clear") ? jsx("div", {
      sel: '.mp-input-right-icon',
      on: {
        click: this.helpers.handleClearInput
      }
    }, jsx(SvgIconEl, {
      attrs: {
        icon: "x"
      }
    })) : null);
  })()), this.attr("validation-status") === "invalid" && this.attr("error-message") ? jsx("div", {
    sel: '.mp-input-error-message'
  }, this.attr("error-message")) : null);
}